/* eslint-disable camelcase */
import store from '@/store'
import xEnum from 'base/utils/enum'
import utils from 'base/utils'

export const EventType = {
  Exp: 'EXP',
  Click: 'CLK',
  Other: 'OTHER'
}

function getUserGlobalParams() {
  const currentSourceEnum = Number(process.env.VUE_APP_SOURCE_ENUM)
  const sourceXEnum = _.find(xEnum.ENUM_DATA_REPORT_SOURCES, (item) => {
    return item.value === currentSourceEnum
  })
  //创建用户唯一会话id
  let userSessionId = ''
  if (window.sessionStorage.getItem('userSessionId')) {
    userSessionId = window.sessionStorage.getItem('userSessionId')
  } else {
    userSessionId = utils.getSessionId()
    window.sessionStorage.setItem('userSessionId', userSessionId)
  }
  const userGlobalParams = {
    project_id: store.state.appState.pId,
    user_id: store.state.user.userId || localStorage.getItem('userId'),
    webUrl: window.location.href,
    timestamp: new Date().getTime(),
    point: store.state.user.points.activePoints,
    source: sourceXEnum.value,
    app_type: store.state.appState.appType,
    phone: store.state.user.phone || '',
    app_branch_type: 'A',
    project_name: store.state.appState.projectName,
    user_session_id: userSessionId
  }

  return userGlobalParams
}
// const appKey = process.env.VUE_APP_QUICK_TRACK_APPKEY

export function loadQuickTrackSDK() {
  // eslint-disable-next-line no-extra-semi
  ;(function (w, d, s, q) {
    w[q] = w[q] || []
    const f = d.getElementsByTagName(s)[0],
      j = d.createElement(s)
    j.async = true
    j.id = 'beacon-aplus'
    j.src = 'https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.umd.js'
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'aplus_queue')

  try {
    if (!window.aplus_queue) return
    const { aplus_queue } = window
    if (!aplus_queue) return

    //集成应用的appKey  暂定所有平台使用同一个应用，此处写死appKey
    aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['appKey', '3hax0vkyr3bxbowm9apqzsup'] })
    //如果是私有云部署还需要在上面那段JS后面紧接着添加日志域名埋点
    //通常私有云日志服务端域名类似于：quickaplus-web-api.xxx.com.cn, 具体域名要找交付同学要
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-rhost-v', 'quickaplus-he-api-cn-shanghai.aliyuncs.com']
    })

    /* 如果使用的是单页面应用，例如：React、Vue、Angular等，则需要添加下面的代码 */
    /* 关闭自动PV发送，如果不是单页面应用，请删掉下方代码 */
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-waiting', 'MAN']
    })
    // aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['DEBUG', true] })

    setUserInfo()
  } catch (error) {
    console.log('error', error)
  }
}

// 设置全局属性
function setUserInfo() {
  const userId = store.state.user.userId || localStorage.getItem('userId')

  try {
    if (!window.aplus_queue) return
    const { aplus_queue } = window
    if (!aplus_queue) return

    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_hold', 'BLOCK']
    })

    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_user_id', userId]
    })

    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_hold', 'START']
    })
  } catch (error) {
    console.log('setUserInfo', error)
  }
}

// 事件日志
export function sendQuickTrackingEvent({ eventName, pageName, eventType, params }) {
  if (!window.aplus_queue) return
  const { aplus_queue } = window
  if (!aplus_queue) return

  const userGlobalParams = getUserGlobalParams()
  const regex = /\/vantmall(.*)/
  const result = regex.exec(window.location.pathname)
  let eventPagePath = ''
  if (result) {
    eventPagePath = result[1].includes('goodsProfile') ? '/goodsProfile' : result[1]
  }
  aplus_queue.push({
    action: 'aplus.appendMetaInfo', //追加全局属性
    arguments: [
      'globalproperty',
      {
        event_page_path: eventPagePath,
        ...userGlobalParams
      }
    ]
  })

  aplus_queue.push({
    action: 'aplus.record',
    arguments: [
      eventName,
      eventType,
      {
        ...params,
        page_name: pageName
      }
    ]
  })
  // console.log('触发事件埋点', params)
}

// 页面日志
export function sendPageTrackEvent({ pageName, params }) {
  if (!window.aplus_queue) return
  const { aplus_queue } = window
  if (!aplus_queue) return

  const userGlobalParams = getUserGlobalParams()
  const regex = /\/vantmall(.*)/
  const result = regex.exec(window.location.pathname)
  let eventPagePath = ''
  if (result) {
    eventPagePath = result[1].includes('goodsProfile') ? '/goodsProfile' : result[1]
  }
  aplus_queue.push({
    action: 'aplus.appendMetaInfo', //追加全局属性
    arguments: [
      'globalproperty',
      {
        event_page_path: eventPagePath,
        ...userGlobalParams
      }
    ]
  })

  aplus_queue.push({
    action: 'aplus.sendPV',
    arguments: [
      {
        is_auto: false
      },
      {
        page_name: pageName,
        ...params
      }
    ]
  })
  // console.log('页面日志', pageName, params)
}

export default {
  loadQuickTrackSDK,
  sendQuickTrackingEvent,
  sendPageTrackEvent
}
